import { Typography } from "antd";
import { CorrecaoContabil } from "../../../../Models/Domain/Viagem/Financeiro/CorrecaoContabil";
import TypeViagem from "../../../../Models/Domain/Viagem/Viagem";
import { extractorNomePessoa } from "../../../../Models/Pessoa/Pessoa";
import { useViagemFehamentoListarContas } from "../../../../Services/Domain/Viagem/ViagemFechadaService";
import Ordenar from "../../../../Utils/Ordenacao";
import Utilitario from "../../../../Utils/Utilitario";
import ResponsiveAntdTable, { ResponsiveAntdTableProps } from "../../../ResponsiveAntdTable";
const { Text } = Typography;

export interface IViagemFechamentoContasTableProps extends ResponsiveAntdTableProps<CorrecaoContabil> {
    viagem: TypeViagem;
}

export default function ViagemFechamentoContasTable({
    viagem,
    ...rest
}:IViagemFechamentoContasTableProps) {
    const {
        data
    } = useViagemFehamentoListarContas({
        codViagem : viagem.codigo ?? 0
    });

    return <ResponsiveAntdTable<CorrecaoContabil, {}>
        {...rest}
        dataSource={data}
        pagination={false}
        columns={[
            {
                title: "Beneficiário",
                dataIndex: ["beneficiario", "nome"],
                render: (value: string, record) => extractorNomePessoa(record.beneficiario!),
                key: 50,
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 6, xxl : 6 }
            },
            {
                title: "Plano de contas",
                dataIndex: ["planoContas", "descricao"],
                key: 50,
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 6, xxl : 6 }
            },
            {
                title: "Pagamento",
                dataIndex: "dataPagamento",
                render: (value: Date) => value.toLocaleDateString(),
                sorter: (ajuste1, ajuste2) => Ordenar.Data(ajuste1.dataPagamento, ajuste2.dataPagamento),
                key: 52,
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 4, xxl : 4 }
            },
            {
                title: "Valor",
                dataIndex: "valor",
                render: (value: number) => <Text type={value > 0 ? "success" : "danger"}>{Utilitario.toStringDinheiro(value)}</Text>,
                sorter: (ajuste1, ajuste2) => Ordenar.Numero(ajuste1.valor, ajuste2.valor),
                key: 53,
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 4, xxl : 4 },
                csv: {
                    title: "Valor (R$)",
                    get: (v) => Utilitario.toCSVDinheiro(v?.valor)
                }
            },
            {
                title: "Comprovante",
                dataIndex: ["comprovante"],
                render(value:string, record) {
                    return (record.urlComprovante ?? '').length > 0 ? <a rel="noopener" href={record.urlComprovante!} target="_blank">{value}</a> : ((value?.length ?? 0) > 0 ? value : " - ");
                },
                key: 54,
                breakpoints : { xs : 24, sm : 12, md : 8, lg : 8, xl : 4, xxl : 4 }
            }
        ]}
        csv={{
            enabled: true,
            filename: "fechamento.csv"
        }}
    />
}